// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { AFS_GRID_FILTER } from 'redux/modules/interferenceAnalysis/constants'

import {
  assignCaseSummaryCaseDetailsTerrCaseId,
  assignCaseSummarySelectedTerrCaseIds,
} from 'redux/modules/interferenceAnalysis'

// Determines if there are cases which are selected but not displayed in the UI.
// This is possible because the user can the visible cases by either changing the
// AFS_GRID_FILTER value applyResultFilter
// OR
// toggling caseSummary.get('showAllCases')
// as a result, this callback is called after those actions take place
// to ensure that the selected set reflects only the visible cases.

const deselectNonVisibleCases = () => (dispatch, getState) => {
  const {
    form,
    interferenceAnalysis,
  } = getState()

  const {
    applyResultFilter,
  } = form[AFS_GRID_FILTER].values

  const caseSummary = interferenceAnalysis.get('caseSummary')
  const caseDetailsTerrCaseId = caseSummary.get('caseDetailsTerrCaseId')
  const channelCaseList = caseSummary.get('channelCaseList')
  const selectedTerrCaseIds = caseSummary.get('selectedTerrCaseIds')
  const showAllCases = caseSummary.get('showAllCases')

  // if there are no selected cases, AND
  // the Case Details drawer isn't open
  // then we don't have to worry about anything there.
  // just get out
  if (selectedTerrCaseIds.size === 0 && caseDetailsTerrCaseId === null) {
    return
  }

  // if we should be applying the AFS Results Filter, then we need to consider
  // the 'filtered' values when conditionally rendering the rows.
  const grayProp = applyResultFilter ? 'isFilteredGray' : 'isGray'

  // determines if grey rows are visible
  const visibleChannelCaseList = (
    showAllCases
      ? channelCaseList
      : channelCaseList.filter(d => !d.get(grayProp))
  )

  // gets a unique List of visible terrCaseIds
  const visibleTerrCaseIds = visibleChannelCaseList.map(d => d.get('terrCaseId')).toSet().toList()

  // filter out the selected ids that aren't visible.
  const newSelectedTerrCaseIds = selectedTerrCaseIds.filter(d => visibleTerrCaseIds.includes(d))

  // if we're changing what's selected, then actually dispatch it.
  // this way we don't force a rerender of the component tree with no actual change to propagate.
  if (newSelectedTerrCaseIds.size !== selectedTerrCaseIds.size) {
    dispatch(assignCaseSummarySelectedTerrCaseIds(newSelectedTerrCaseIds))
  }

  // if the Case Details drawer is currently open but it's corresponding terrCaseId is
  // no longer visible, then hide the drawer.
  if (caseDetailsTerrCaseId && visibleTerrCaseIds.includes(caseDetailsTerrCaseId) === false) {
    dispatch(assignCaseSummaryCaseDetailsTerrCaseId(null))
  }
}

export default deselectNonVisibleCases
